import { AxiosResponseAction, IReduxAction } from '../reducers'
import { DataPromise, DataPromiseState, getDataPromiseState } from '../context/AxiosContext'
import { AxiosError } from 'axios'

export function getPendingState<S>(state: S, key: string): S {
    const copy: Pick<DataPromise, 'data' | 'settings'> = { ...state[key] }
    return {
        ...state,
        [key]: {
            ...getDataPromiseState(DataPromiseState.Loading, copy.data, copy.settings),
            loaded: state[key]?.loaded || false,
            rejected: state[key]?.rejected || false,
        },
    }
}

export function getRejectedState<S>(state: S, data: IReduxAction<AxiosError>, key: string): S {
    const copy: Pick<DataPromise, 'data' | 'settings'> = { ...state[key] }
    return {
        ...state,
        [key]: getDataPromiseState(DataPromiseState.Rejected, copy.data, copy.settings, data?.payload),
    }
}

export function getFulfilledState<S>(state: S, data: any, key: string): S {
    const copy: Pick<DataPromise, 'settings'> = { ...state[key] }
    return {
        ...state,
        [key]: getDataPromiseState(DataPromiseState.Loaded, data, copy.settings),
    }
}

export function getSettingsState<S>(state: S, action: Pick<IReduxAction, 'payload'>, key: string): S {
    return {
        ...state,
        [key]: {
            ...state[key],
            settings: {
                ...state[key].settings,
                ...action.payload,
            },
            loaded: false,
        },
    }
}

export function getAxiosFulfilledState<S>(state: S, action: Pick<AxiosResponseAction, 'payload'>, key: string): S {
    return action.payload?.data !== undefined
        ? getFulfilledState<S>(state, action.payload.data, key)
        : // Nothing has changed yet if we didn't get any payload data. This can happen when re-authorisation is in
          // progress.
          state
}

export function resetState<S>(state: S, data): S {
    const newState: S = { ...state }
    Object.keys(data).forEach((key: string) => {
        newState[key] = {
            ...state[key],
            data: data[key],
            loading: false,
            loaded: false,
            rejected: false,
        }
    })
    return newState
}
